import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class ShiftService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  LoadShiftMaster(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Attendance/LoadShiftMaster`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ShiftMasterInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ShiftMaster/InsertUpdate`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ShiftRuleLoadGet(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ShiftRuleLoad/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ShiftRuleInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ShiftRuleInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Proc_ESS_ShiftMaster_BulkInsert(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Proc_ESS_ShiftMaster_BulkInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
